import { performPostToBackend } from './backend-api';
import { useRtmStore } from '@/stores/RtmStore';
import { useRtmFiltersStore } from '@/stores/RtmFiltersStore';

import { Timer } from '@/types/Api';
import { filterAlerts } from '@/utils/errors';

const startTimer = async (chatId: string | undefined) => {
  const trackRtmTime = JSON.parse(
    localStorage.getItem('userData') || 'null'
  )?.trackRtmTime;
  if (!chatId || !trackRtmTime) return null;
  const store = useRtmStore();
  try {
    const response = await performPostToBackend('/timer/start', {
      chatId,
      treatment: useRtmFiltersStore().treatment,
    });
    const timer: Timer = response.data;
    store.upsertTimers(timer);
    return timer;
  } catch (error) {
    // sentry alerts on this are not useful to us
    filterAlerts(error, 404);
    return null;
  }
};

const stopTimer = async (chatId: string | undefined) => {
  const trackRtmTime = JSON.parse(
    localStorage.getItem('userData') || 'null'
  )?.trackRtmTime;
  if (!chatId || !trackRtmTime) return null;
  const store = useRtmStore();
  try {
    const response = await performPostToBackend('/timer/stop', { chatId });
    const timer: Timer = response.data;
    store.upsertTimers(timer);
    return timer;
  } catch (error) {
    // sentry alerts on this are not useful to us
    filterAlerts(error, 404);
    return null;
  }
};

const getTimers = async (chatId: string | undefined) => {
  if (!chatId) return [];
  const store = useRtmStore();
  try {
    const response = await performPostToBackend('/timer/logs', { chatId });
    const timers: Timer[] = response.data;
    store.upsertTimers(timers);
    return timers;
  } catch (error) {
    // sentry alerts on this are not useful to us
    filterAlerts(error, 404);
    return [];
  }
};

export { startTimer, stopTimer, getTimers };
